export default "__VITE_ASSET__Ll5qtHN3__"